import React, { useState } from "react";
import "../../page_content.css";

const PlacementCell = () => {
  return (
    <div>
      <h1 className="title">Placement Cell</h1>
      <hr />
      <div className="page-content-container">
        <div>
          <p>
            MANET Pune has specially instituted Training and Placement Cell that
            interacts with the reputed shipping companies to place maximum
            number of eligible cadets from B. Tech. - Marine Engineering & B.Sc.
            - Nautical Science. At MANET Pune, we always strive for the perfect
            placement record, helping our cadets get the perfect start for a
            rewarding career at sea. Almost every year, the MANET placement
            record has been 100% and our cadets have been placed in the most
            reputed Indian and foreign shipping companies.
          </p>
          <p>
            MANET Pune was established in 2001, and the first batch of B. Tech
            Marine Engineering was graduated in 2004. Now our cadets are sailing
            across the globe with reputable shipping companies. Some cadets,
            after clearing their COC examinations of DGS and other required
            courses, are successfully handling the responsibility of Chief
            Engineers. We're extremely proud of our cadets and continue to
            inspire them by staying connected through the Alumni connect.
          </p>
          <p>
            MANET Pune has started B.Sc. Nautical Science course in 2010, and
            the first batch was graduated in 2013. The graduated cadets have
            joined the shipping industry as Trainee Navigating Officers and are
            now navigating across the different oceans. Some of our cadets are
            preparing to get the paramount rank in nautical domain i.e. Captain
            of the ship.
          </p>
          <p>
            MANET believes in imparting complete education encompassing
            academics, hands-on training, soft skills etc. which ultimately
            leads to the best placement record. Based on the framework drawn by
            D. G. Shipping, the qualified and experienced staff at MANET strive
            to impart in-depth knowledge along with primary focus on practical
            training, thus customizing the education to the needs of today's
            shipping industry.
          </p>
          <p>
            Most of the reputed shipping companies start their placement process
            in third year for B. Tech. - Marine Engineering cadets & in second
            year for B.Sc. - Nautical Science cadets. Cadets with no backlogs
            can register for the placement process & can get placed in renowned
            shipping companies.
          </p>
          <p>
            Placement cell also provides assistance to the MANET Alumni at their
            different career stages for further developments.
          </p>
        </div>

        <div className="placement-images "><img src="/assets/images/Placement/image (1).webp" />
          <img src="/assets/images/Placement/image (2).webp" /></div>


        <div>
          <h4 className="innerpage-heading ">Objectives of Placement Cell</h4>
          <ul className="page-content-lists">
            <li>
              To train the cadets of 4 years B. Tech. -Marine Engineering & 3
              Years B.Sc. - Nautical Science in various fields which are
              necessary for placement processes, as per the changing trends in
              shipping industry, complying with DG shipping.
            </li>
            <li>
              To get maximum cadets of 4 years B. Tech. -Marine Engineering & 3
              Years B.Sc. - Nautical Science placed in shipping or related
              companies per year.
            </li>
            <li>
              To co-ordinate with various shipping companies in a view of
              getting new companies for campus interviews.
            </li>
            <li>
              To motivate cadets to acquire technical knowledge and soft skills
              in terms of career planning and goal setting.
            </li>
            <li>
              Follow-up with the changing dynamics of the shipping industry and
              groom the cadets.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="innerpage-heading ">Placement Process</h2>
          <ul className="page-content-lists">
            <li>Placement cell connects with the shipping companies.</li>
            <li>
              Shipping company mentions the requirement & eligibility criteria
              for placement drive.
            </li>
            <li>
              The company may ask
              <ul>
                <li>Total list of cadets or</li>
                <li>
                  Shortlisted cadets by mentioning the specific requirement.
                </li>
              </ul>
            </li>
            <li>
              The placement cell coordinates with the company for further
              placement drive steps.
            </li>
            <li>
              The placement drive can be conducted online, offline, or hybrid
              mode (as per the company's convenience).
            </li>
            <li>
              General steps in placement drive (Online/Offline) are as follows:
              <ul>
                <li>Test (PI/PLI/OPQ/Technical)</li>
                <li>Interview (lor 2 rounds)</li>
                <li>
                  Physical Medical examination at the company approved medical
                  center.
                </li>
              </ul>
            </li>
            <li>Company communicates the final selection through mail.</li>
            <li>
              Placement cell issues a notice about the selection of cadets.
            </li>
            <li>
              Placement cell updates the records & data at university portals,
              websites, etc.
            </li>
            <li>
              Placement cell updates the company on cadet's progress
              periodically.
            </li>
          </ul>
        </div>

        <div>
          <h4 className="innerpage-heading ">Placement Initiatives</h4>
          <ul className="page-content-lists">
            <li>Placement Induction Program</li>
            <li>Specially curated Comprehensive Training Plan</li>
            <li>Soft Skills training</li>
            <li>Officer Like Quality (OLQ) Training</li>
            <li>Enclosed Space Entry Course</li>
            <li>4G Welding Course</li>
            <li>Gas Carrier Ship Familiarization Course</li>
            <li>Special Electrical Training</li>
            <li>Hydraulics & Pneumatic</li>
            <li>Advance Welding and Cutting</li>
            <li>Safety drills</li>
            <li>MANET Milieu (Grand Shipping Industry Conclave)</li>
            <li>MOU with 'The Naval Connection' & "Orzel Maritime'.</li>
            <li>
              Presence in all maritime events as a sponsor or partner for
              company connect & branding. 15. Alumni Events
            </li>
            <li>Alumni Events</li>
            <li>STCW certifications</li>
            <li>On-board training & Port visits</li>
            <li>Ship-in-Campus Training</li>
            <li>
              Undertaking by the cadets to abide by the rules & regulations.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PlacementCell;
